import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden" data-id="element-113">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-114" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-116">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-cream mb-8 leading-tight" data-id="element-117">
            💪 SÌ! VOGLIO{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-118">
              RIVOLUZIONARE
            </span>{' '}
            LE MIE LEZIONI ORA
          </h2>

          <CTAButton href={CART_URL} className="text-xl sm:text-2xl py-6 px-10 w-full sm:w-auto max-w-xl mx-auto mb-6" data-id="element-119">
            SÌ! VOGLIO IL METODO COMPLETO
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 text-brand-gold font-bold text-sm sm:text-base" data-id="element-120">
            <span data-id="element-121">⚡ Accesso Immediato</span>
            <span data-id="element-122">·</span>
            <span data-id="element-123">🛡️ Garanzia di 14 Giorni</span>
          </div>
        </motion.div>
      </div>
    </section>;
}